/* bm-combo-armar-ficha — v116 · punto 026 (Wil, 8-oct-2026: «está perfecto, aplícalo»).
   Arma el Combo ×2 dentro de la ficha del modelo (snippets/bm-bundle.liquid):
   - Bolso 1 = color de esta ficha + sus iniciales. Se leen y se escriben en el campo de bm-personalizer
     (#bmPersoInput1 y su casilla «Sin iniciales»): si la clienta las escribe dentro del armado, se copian
     a ese campo con su evento normal, así el personalizador y su campo oculto quedan iguales.
   - 2.º bolso: colores reales del combo (variante "Color + Color" con el color de esta ficha) e iniciales.
   - Agrega la VARIANTE REAL del combo con las iniciales como propiedades de línea con los MISMOS
     nombres que usa bm-personalizer en la ficha del combo: "<Tote Bag|MINI Tote Bag> <Color>[ PRO] (0N) - Iniciales".
     Esos nombres los leen bm-note-sync (nota del pedido) y el guardián de iniciales de BM Pro (orders/create).
   Si algo no cuadra, la opción «Combo ×2» sigue siendo el enlace a la ficha del combo (sin JS también).
   v118 · punto 16 (Wil, 15-oct-2026): el MISMO armado en la ficha DIRECTA del combo (data "direct": true):
   el combo ya viene elegido (sin «1 unidad»), el 1.er bolso elige color entre los colores reales de las
   variantes del combo y sus iniciales viven aquí (no en el personalizador de 2 bolsos, que se esconde).
   Mismo panel, misma vista previa, mismo resumen, mismo «Agregar combo», misma variante y mismas propiedades.
   Si no se puede armar, el bloque se esconde (data-arm-fail) y la ficha del combo queda como antes. */
(function () {
  'use strict';

  var ICON_CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  /* Íconos Lucide (truck, shield-check, sparkles) — los mismos del diseño aprobado. */
  var ICON_TRUCK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>';
  var ICON_SHIELD = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg>';
  var ICON_SPARK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9.94 15.5A2 2 0 0 0 8.5 14.06l-6.14-1.58a.5.5 0 0 1 0-.96L8.5 9.94A2 2 0 0 0 9.94 8.5l1.58-6.14a.5.5 0 0 1 .96 0l1.58 6.14a2 2 0 0 0 1.44 1.44l6.14 1.58a.5.5 0 0 1 0 .96l-6.14 1.58a2 2 0 0 0-1.44 1.44l-1.58 6.14a.5.5 0 0 1-.96 0z"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* COP sin decimales con punto de miles: 39990000 (centavos) -> "$399.900" */
  function money(cents) {
    var n = Math.round((Number(cents) || 0) / 100);
    var neg = n < 0; n = Math.abs(n);
    return (neg ? '-' : '') + '$' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  function cap(s) { s = String(s || ''); return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
  /* Misma limpieza que bm-personalizer (clean): mayúsculas, solo letras, máximo N. */
  function clean(v, mx) { return String(v || '').toUpperCase().replace(/[^A-ZÁÉÍÓÚÜÑ]/g, '').slice(0, mx); }
  /* "Black + Beige" / "Supra Blue+Black" -> ["black","beige"] / ["blue","black"] */
  function pairOf(title) {
    var parts = String(title || '').toLowerCase().split('+');
    if (parts.length !== 2) return null;
    return parts.map(function (x) { var w = x.trim().split(/\s+/); return w[w.length - 1]; });
  }

  function init(root) {
    if (!root || root.__bmArm) return;
    root.__bmArm = true;
    /* Ficha directa del combo: si no se puede armar, se esconde el bloque y vuelven el personalizador,
       el selector y el botón normales (los esconde un <style> del snippet mientras no haya data-arm-fail). */
    function fail() {
      if (root.hasAttribute('data-arm-direct')) { root.setAttribute('data-arm-fail', ''); root.hidden = true; }
    }
    var D;
    try { D = JSON.parse(root.querySelector('script[data-arm-data]').textContent); } catch (e) { return fail(); }
    var direct = !!D.direct;

    var one = root.querySelector('[data-arm-one]');
    var card = root.querySelector('[data-arm-card]');
    var head = root.querySelector('[data-arm-combo]');
    var panel = root.querySelector('[data-arm-panel]');
    var pairEl = root.querySelector('[data-arm-pair]');
    var subEl = root.querySelector('[data-arm-sub]');
    var hpriceEl = root.querySelector('[data-arm-hprice]');
    var tagsaveEl = root.querySelector('[data-arm-tagsave]');
    var live = root.querySelector('[data-arm-live]');
    if ((!one && !direct) || !card || !head || !panel) return fail();

    /* El bolso 1 toma las iniciales del personalizador de ESTA ficha. Si el combo pide iniciales y
       la ficha no tiene personalizador, no se arma aquí: la opción sigue siendo el enlace.
       En la ficha directa del combo las iniciales del bolso 1 se guardan aquí mismo (b1). */
    var b1Input = direct ? null : document.getElementById('bmPersoInput1');
    if (D.perso && !direct && !b1Input) return;

    var sec = root.closest('[id^="MainProduct-"]') || root.closest('product-info') || document.body;
    var maxB2 = parseInt(D.maxLetras, 10) || 2;
    var maxB1 = b1Input ? (parseInt(b1Input.getAttribute('data-bm-max'), 10) || maxB2) : maxB2;

    /* ---------- Opciones del 2.º color ---------- */
    function sibFor(tok) {
      for (var i = 0; i < D.sibs.length; i++) {
        if (String(D.sibs[i].name || '').toLowerCase() === tok) return D.sibs[i];
      }
      return null;
    }
    var curSib = null;
    for (var si = 0; si < D.sibs.length; si++) { if (D.sibs[si].self) curSib = D.sibs[si]; }
    /* Bolso 1: en la ficha del modelo es el de la ficha; en la ficha directa del combo se elige (b1opts). */
    var cur = direct ? null : { tok: D.cur.tok, name: D.cur.name, img: D.cur.img, hex: D.cur.hex, pv: D.cur.pv, price: D.unitPrice };
    /* Opciones del 2.º bolso para un color del 1.º (c). */
    function optsFor(c) {
      var list = [];
      if (D.single) {
        /* Combo de un solo color (ej. Combo Tote Bag PRO Black): el 2.º bolso es igual al 1.º. */
        var v0 = D.variants[0];
        list.push({ tok: c.tok, name: c.name, v: v0, img: c.img, hex: c.hex, price: c.price, out: !v0.available });
        return list;
      }
      var byOther = {}, order = [];
      D.variants.forEach(function (v) {
        var pr = pairOf(v.title);
        if (!pr) return;
        var other = null;
        if (pr[0] === c.tok) other = pr[1];
        else if (pr[1] === c.tok) other = pr[0];
        if (other === null || byOther[other]) return;
        byOther[other] = v;
      });
      /* Mismo orden de los colores de la ficha; los que no tienen ficha suelta, al final. */
      D.sibs.forEach(function (s) { var t = String(s.name || '').toLowerCase(); if (byOther[t] && order.indexOf(t) === -1) order.push(t); });
      Object.keys(byOther).forEach(function (t) { if (order.indexOf(t) === -1) order.push(t); });
      order.forEach(function (t) {
        var v = byOther[t], s = sibFor(t);
        /* Agotado = la variante del combo está agotada o la ficha suelta de ese color está agotada
           (igual que en los colores de la ficha). */
        var out = !v.available || !!(s && !s.available);
        if (!s && out) return; /* color sin ficha y agotado: no aporta nada */
        list.push({ tok: t, name: s ? s.name : cap(t), v: v, img: s ? s.img : '', hex: s ? s.hex : '', price: s ? s.price : c.price, out: out });
      });
      return list;
    }
    /* «El más pedido»: variante del combo que se vende sin tope de inventario (continue) y cuyo
       inventario negativo = unidades ya vendidas. Solo si hay al menos 10 y hay con qué comparar. */
    function bestOf(list) {
      var av = list.filter(function (o) { return !o.out; }), b = null;
      if (av.length > 1) {
        av.forEach(function (o) {
          if (o.v.policy === 'continue' && Number(o.v.inv) <= -10 && (!b || Number(o.v.inv) < Number(b.v.inv))) b = o;
        });
      }
      return b;
    }

    /* Ficha directa: colores del 1.er bolso = colores reales de las variantes del combo (orden de las fichas).
       Agotado = no le queda ninguna pareja disponible o su ficha suelta está agotada. */
    var b1opts = [];
    if (direct) {
      if (D.single) {
        D.sibs.forEach(function (s) {
          var tk = String(s.name || '').trim().split(/\s+/)[0].toLowerCase();
          b1opts.push({ tok: tk, name: s.name, img: s.img, hex: s.hex, pv: null, price: s.price, out: !s.available || !D.variants[0].available });
        });
      } else {
        var toks = [], ordered = [];
        D.variants.forEach(function (v) {
          var pr = pairOf(v.title);
          if (pr) pr.forEach(function (t) { if (toks.indexOf(t) === -1) toks.push(t); });
        });
        D.sibs.forEach(function (s) { var t = String(s.name || '').toLowerCase(); if (toks.indexOf(t) > -1 && ordered.indexOf(t) === -1) ordered.push(t); });
        toks.forEach(function (t) { if (ordered.indexOf(t) === -1) ordered.push(t); });
        ordered.forEach(function (t) {
          var s = sibFor(t);
          var c = { tok: t, name: s ? s.name : cap(t), img: s ? s.img : '', hex: s ? s.hex : '', pv: null, price: s ? s.price : null };
          c.out = !!(s && !s.available) || !optsFor(c).some(function (o) { return !o.out; });
          if (!s && c.out) return;
          b1opts.push(c);
        });
      }
      var avB1 = b1opts.filter(function (o) { return !o.out; });
      if (!avB1.length) return fail();
      /* ?variant= en la URL (ej. «Black + Beige»): el armado arranca con esa pareja. */
      var pre = D.pre ? pairOf(D.pre) : null, preB = null;
      if (pre) {
        var pa = avB1.filter(function (o) { return o.tok === pre[0]; })[0];
        var pb = avB1.filter(function (o) { return o.tok === pre[1]; })[0];
        if (pa) { cur = pa; preB = pre[1]; } else if (pb) { cur = pb; preB = pre[0]; }
      }
      if (!cur) cur = avB1[0];
    }

    var opts = [], best = null, sel = null;
    function setOpts(wantTok) {
      opts = optsFor(cur);
      var avail = opts.filter(function (o) { return !o.out; });
      best = bestOf(opts);
      var keep = wantTok ? avail.filter(function (o) { return o.tok === wantTok; })[0] : null;
      sel = keep || best || avail.filter(function (o) { return o.tok === cur.tok; })[0] || avail[0] || null;
    }
    setOpts(direct ? preB : null);
    if (!sel) return fail(); /* nada que armar: queda el enlace */

    /* ---------- Estado ---------- */
    var on = false, built = false, busy = false, b1Editing = false;
    var b1 = { val: '', sin: false }; /* iniciales del bolso 1 en la ficha directa del combo */
    var b2 = { val: '', sin: false };
    var els = {};

    function noIni1() { return document.querySelector('#bmPerso .bm-perso__noini-cb[data-bag="1"]'); }
    function bag1() {
      if (!D.perso) return { ok: true, val: '', sin: false };
      if (direct) return { ok: b1.sin || b1.val.length > 0, val: b1.val, sin: b1.sin };
      var cb = noIni1();
      var sin = !!(cb && cb.checked);
      var val = clean(b1Input ? b1Input.value : '', maxB1);
      return { ok: sin || val.length > 0, val: val, sin: sin };
    }
    function b2ok() { return !D.perso || b2.sin || b2.val.length > 0; }
    function prices() {
      var combo = Number(sel.v.price) || 0;
      /* Precio de cada bolso suelto = su ficha suelta real; si a uno le falta la ficha, se toma el del otro. */
      var p1 = Number(cur.price) || 0, p2 = Number(sel.price) || 0;
      if (!p1) p1 = p2;
      if (!p2) p2 = p1;
      var sueltos = p1 + p2;
      return { combo: combo, each: combo / 2, sueltos: sueltos, ahorro: sueltos > 0 ? sueltos - combo : 0 };
    }
    function modelName(tok, name) {
      if (D.perso) return D.bagLabel + ' ' + cap(tok) + D.proSuffix;
      /* "Supra Black+Black" -> modelo "Supra"; se escribe como en el título de la ficha ("SUPRA"). */
      var w = String(sel.v.title || '').split('+')[0].trim().split(/\s+/);
      /* v121 · 19-oct-2026 (078): el modelo son TODAS las palabras antes del color («Classic PRO Black» → «Classic PRO»);
         antes tomaba solo la primera y el Combo Classic PRO decía «Classic Black». */
      var model = w.length > 1 ? w.slice(0, -1).join(' ') : '';
      if (model) {
        var m = String(D.productTitle || '').match(new RegExp('\\b' + model + '\\b', 'i'));
        if (m) model = m[0];
      }
      return (model ? model + ' ' : '') + name;
    }
    function pvHtml(tok, letters, extra, useCurPv) {
      var src = (useCurPv && cur.pv) ? cur.pv : (D.single && cur.pv ? cur.pv : (D.pv[tok] || ''));
      var cls = 'bm-arm__pv bm-arm__pv--' + esc(tok) + (D.mini ? ' bm-arm__pv--mini' : '') + (extra ? ' ' + extra : '');
      return '<span class="' + cls + '">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy">' : '') +
        (letters ? '<b>' + esc(letters) + '</b>' : '') + '</span>';
    }
    function plainHtml(img, extra) {
      return '<span class="bm-arm__pv bm-arm__pv--plain' + (extra ? ' ' + extra : '') + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span>';
    }

    /* Botones de color (2.º bolso; y 1.er bolso en la ficha directa). g = «1» o «2». */
    function swsHtml(list, bst, g) {
      var h = '';
      list.forEach(function (o, i) {
        h += '<button type="button" class="bm-arm__sw' + (o.out ? ' is-out' : '') + '" role="radio" aria-checked="false" data-g="' + g + '" data-i="' + i + '"' +
          (o.out ? ' aria-disabled="true"' : '') + ' aria-label="' + esc(o.name) + (o.out ? ' (agotado)' : '') + '">' +
          (bst === o ? '<span class="bm-arm__best">El más pedido</span>' : '') +
          '<span class="bm-arm__swimg">' + (o.img ? '<img src="' + esc(o.img) + '" alt="" loading="lazy" width="68" height="68">' : '<span class="bm-arm__swdot" style="background:' + esc(o.hex || '#C7C7CC') + '"></span>') + '</span>' +
          '<span class="bm-arm__chk">' + ICON_CHECK + '</span>' +
          '<span class="bm-arm__swnm">' + (o.out ? 'Agotado' : esc(o.name)) + '</span>' +
          '</button>';
      });
      return h;
    }
    function swList(g) { return g === '1' ? b1opts : opts; }
    function swAll() { return Array.prototype.slice.call(panel.querySelectorAll('.bm-arm__sw')); }

    /* ---------- Construcción del panel (una vez, al abrir) ---------- */
    function build() {
      if (built) return;
      built = true;
      var h = '';
      h += '<div class="bm-arm__b1">' +
        '<span data-arm-b1-thumb></span>' +
        '<span class="bm-arm__b1tx"><span class="bm-arm__b1a" data-arm-b1-name>Bolso 1 · ' + esc(cur.name) + '</span><span class="bm-arm__b1b" data-arm-b1-sub></span></span>' +
        '<span class="bm-arm__ok" data-arm-b1-ok>' + ICON_CHECK + '</span>' +
        '<button type="button" class="bm-arm__link" data-arm-b1-edit hidden>Cambiar</button>' +
        '</div>';
      if (direct && b1opts.length > 1) {
        h += '<div class="bm-arm__b1c' + (D.perso ? ' bm-arm__b1c--join' : '') + '">' +
          '<div class="bm-arm__h"><span class="bm-arm__ha" id="bmArmColor1H">Elige el 1.er color</span><span class="bm-arm__hb" data-arm-colorname1></span></div>' +
          '<div class="bm-arm__sws" role="radiogroup" aria-labelledby="bmArmColor1H" data-arm-sws1>' + swsHtml(b1opts, null, '1') + '</div>' +
          '</div>';
      }
      if (D.perso) {
        h += '<div class="bm-arm__b1ed" data-arm-b1ed hidden>' +
          '<div class="bm-arm__h"><label class="bm-arm__ha" for="bmArmIni1">Iniciales del 1.er bolso</label><span class="bm-arm__hb">' + (maxB1 === 1 ? 'Solo 1 letra' : 'Máximo ' + maxB1 + ' letras') + '</span></div>' +
          '<div class="bm-arm__ini">' +
          '<input id="bmArmIni1" class="bm-arm__inp" type="text" maxlength="' + maxB1 + '" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="' + (maxB1 === 1 ? 'Ej: B' : 'Ej: BM') + '" data-arm-ini1>' +
          '<span data-arm-pv1></span>' +
          '</div>' +
          '<div class="bm-arm__chips"><button type="button" class="bm-arm__chip" aria-pressed="false" data-arm-sin1>Sin iniciales</button></div>' +
          '</div>';
      }
      h += '<div class="bm-arm__b2" data-arm-b2>';
      h += '<div class="bm-arm__h"><span class="bm-arm__ha" id="bmArmColorH">' + (D.single ? 'Color del 2.º bolso' : 'Elige el 2.º color') + '</span><span class="bm-arm__hb" data-arm-colorname></span></div>';
      h += '<div class="bm-arm__sws" role="radiogroup" aria-labelledby="bmArmColorH" data-arm-sws2>' + swsHtml(opts, best, '2') + '</div>';
      if (D.perso) {
        h += '<div class="bm-arm__h" style="margin-top:16px"><label class="bm-arm__ha" for="bmArmIni2">Iniciales del 2.º bolso</label><span class="bm-arm__hb">' + (maxB2 === 1 ? 'Solo 1 letra' : 'Máximo ' + maxB2 + ' letras') + '</span></div>' +
          '<div class="bm-arm__ini">' +
          '<input id="bmArmIni2" class="bm-arm__inp" type="text" maxlength="' + maxB2 + '" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="' + (maxB2 === 1 ? 'Ej: A' : 'Ej: AC') + '" data-arm-ini2>' +
          '<span data-arm-pv2></span>' +
          '</div>' +
          '<div class="bm-arm__chips">' +
          '<button type="button" class="bm-arm__chip" data-arm-same hidden></button>' +
          '<button type="button" class="bm-arm__chip" aria-pressed="false" data-arm-sin>Sin iniciales</button>' +
          '</div>' +
          '<p class="bm-arm__hint">Las bordamos a mano sobre cada bolso.</p>';
      }
      h += '</div>';
      panel.innerHTML = h;

      var out = document.createElement('div');
      out.className = 'bm-arm__out';
      out.setAttribute('data-arm-out', '');
      out.hidden = true;
      out.innerHTML =
        '<div class="bm-arm__save" data-arm-save>' + ICON_CHECK + '<span data-arm-save-t></span></div>' +
        '<div class="bm-arm__sum">' +
        '<div class="bm-arm__done" data-arm-done><span class="bm-arm__ok">' + ICON_CHECK + '</span><span class="bm-arm__dt">Tu combo está listo</span><button type="button" class="bm-arm__link" data-arm-edit>Editar</button></div>' +
        '<div class="bm-arm__done" data-arm-pend hidden><span class="bm-arm__dt">Completa tu combo</span></div>' +
        '<div class="bm-arm__stage" data-arm-stage></div>' +
        '<div class="bm-arm__lines" data-arm-lines></div>' +
        '<ul class="bm-arm__falta" data-arm-falta hidden></ul>' +
        '<div class="bm-arm__tot"><div><div class="bm-arm__ta" data-arm-ta></div><div class="bm-arm__tb" data-arm-tb></div></div>' +
        '<div class="bm-arm__tr"><span class="bm-arm__was" data-arm-was></span><span class="bm-arm__pill" data-arm-pill></span></div></div>' +
        '<div class="bm-arm__trust" data-arm-trust></div>' +
        '<button type="button" class="bm-arm__btn" data-arm-add></button>' +
        '<p class="bm-arm__after" data-arm-after></p>' +
        '<p class="bm-arm__err" role="alert" data-arm-err hidden></p>' +
        '<p class="bm-arm__ok-msg" data-arm-okmsg hidden>Listo: tu combo quedó en el carrito.</p>' +
        '</div>';
      card.parentNode.insertBefore(out, card.nextSibling);

      els.out = out;
      els.b1thumb = panel.querySelector('[data-arm-b1-thumb]');
      els.b1name = panel.querySelector('[data-arm-b1-name]');
      els.colorname1 = panel.querySelector('[data-arm-colorname1]');
      els.sws2 = panel.querySelector('[data-arm-sws2]');
      els.b1sub = panel.querySelector('[data-arm-b1-sub]');
      els.b1ok = panel.querySelector('[data-arm-b1-ok]');
      els.b1edit = panel.querySelector('[data-arm-b1-edit]');
      els.b1ed = panel.querySelector('[data-arm-b1ed]');
      els.ini1 = panel.querySelector('[data-arm-ini1]');
      els.pv1 = panel.querySelector('[data-arm-pv1]');
      els.sin1 = panel.querySelector('[data-arm-sin1]');
      els.b2 = panel.querySelector('[data-arm-b2]');
      els.colorname = panel.querySelector('[data-arm-colorname]');
      els.sws = swAll();
      els.ini2 = panel.querySelector('[data-arm-ini2]');
      els.pv2 = panel.querySelector('[data-arm-pv2]');
      els.same = panel.querySelector('[data-arm-same]');
      els.sin = panel.querySelector('[data-arm-sin]');
      els.saveT = out.querySelector('[data-arm-save-t]');
      els.save = out.querySelector('[data-arm-save]');
      els.done = out.querySelector('[data-arm-done]');
      els.pend = out.querySelector('[data-arm-pend]');
      els.edit = out.querySelector('[data-arm-edit]');
      els.stage = out.querySelector('[data-arm-stage]');
      els.lines = out.querySelector('[data-arm-lines]');
      els.falta = out.querySelector('[data-arm-falta]');
      els.ta = out.querySelector('[data-arm-ta]');
      els.tb = out.querySelector('[data-arm-tb]');
      els.was = out.querySelector('[data-arm-was]');
      els.pill = out.querySelector('[data-arm-pill]');
      els.trust = out.querySelector('[data-arm-trust]');
      els.add = out.querySelector('[data-arm-add]');
      els.after = out.querySelector('[data-arm-after]');
      els.err = out.querySelector('[data-arm-err]');
      els.okmsg = out.querySelector('[data-arm-okmsg]');

      /* Un solo manejador para los colores (los del 2.º bolso se repintan al cambiar el 1.º). */
      panel.addEventListener('click', function (e) {
        var b = e.target && e.target.closest ? e.target.closest('.bm-arm__sw') : null;
        if (!b || !panel.contains(b)) return;
        var g = b.getAttribute('data-g') || '2';
        var o = swList(g)[Number(b.getAttribute('data-i'))];
        if (!o || o.out) return;
        if (g === '1') {
          if (o === cur) return;
          var keepTok = sel ? sel.tok : null;
          cur = o;
          setOpts(keepTok);
          els.sws2.innerHTML = swsHtml(opts, best, '2');
          els.sws = swAll();
        } else {
          sel = o;
        }
        hideMsgs();
        update();
      });
      panel.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var b = e.target && e.target.closest ? e.target.closest('.bm-arm__sw') : null;
        if (!b) return;
        e.preventDefault();
        var g = b.getAttribute('data-g') || '2', list = swList(g);
        var grp = els.sws.filter(function (x) { return (x.getAttribute('data-g') || '2') === g; });
        var i = grp.indexOf(b), n = grp.length;
        for (var k = 1; k <= n; k++) {
          var j = (i + (e.key === 'ArrowRight' ? k : -k) + n) % n;
          if (!list[j].out) { grp[j].focus(); grp[j].click(); break; }
        }
      });
      if (els.ini2) {
        els.ini2.addEventListener('input', function () {
          var c = clean(els.ini2.value, maxB2);
          if (els.ini2.value !== c) els.ini2.value = c;
          b2.val = c; hideMsgs(); update();
        });
      }
      if (els.same) {
        els.same.addEventListener('click', function () {
          var b = bag1(); if (!b.val) return;
          b2.sin = false; b2.val = clean(b.val, maxB2);
          if (els.ini2) els.ini2.value = b2.val;
          hideMsgs(); update();
        });
      }
      if (els.sin) {
        els.sin.addEventListener('click', function () {
          b2.sin = !b2.sin;
          hideMsgs(); update();
          if (!b2.sin && els.ini2) els.ini2.focus();
        });
      }
      if (els.b1edit) els.b1edit.addEventListener('click', goBag1);
      if (els.ini1) {
        /* Lo escrito aquí va al campo del personalizador con su evento normal: él limpia, pinta su
           vista previa y llena su campo oculto; nosotros solo leemos de ahí. */
        els.ini1.addEventListener('input', function () {
          var c = clean(els.ini1.value, maxB1);
          if (els.ini1.value !== c) els.ini1.value = c;
          if (direct) b1.val = c;
          else if (b1Input && b1Input.value !== c) {
            b1Input.value = c;
            b1Input.dispatchEvent(new Event('input', { bubbles: true }));
          }
          hideMsgs(); update();
        });
      }
      if (els.sin1) {
        els.sin1.addEventListener('click', function () {
          if (direct) b1.sin = !b1.sin;
          else { var cb = noIni1(); if (cb) cb.click(); /* dispara el «change» del personalizador */ }
          hideMsgs(); update();
          if (!bag1().sin && els.ini1) els.ini1.focus();
        });
      }
      if (els.edit) els.edit.addEventListener('click', function () {
        els.b2.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var s2 = els.sws.filter(function (b) { return b.getAttribute('data-g') !== '1'; });
        var f = s2.filter(function (b) { return b.classList.contains('is-on'); })[0] || s2[0];
        setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) {} }, 350);
      });
      els.add.addEventListener('click', addCombo);
      buildSticky();
    }

    /* ---------- Pintar estado ---------- */
    function update() {
      var pr = prices();
      var b = bag1();
      /* Fila del combo (también cerrada) */
      if (subEl) {
        subEl.innerHTML = on
          ? '<strong>2 por ' + money(pr.combo) + '</strong> · ' + money(pr.each) + ' cada uno'
          : money(pr.each) + ' c/u' + (pr.ahorro > 0 ? ' · <b>ahorras ' + money(pr.ahorro) + '</b>' : '');
      }
      if (hpriceEl) hpriceEl.textContent = money(pr.combo);
      if (tagsaveEl) { tagsaveEl.textContent = 'Ahorras ' + money(pr.ahorro); tagsaveEl.hidden = !(pr.ahorro > 0); }
      if (pairEl) {
        pairEl.innerHTML = '<img src="' + esc(cur.img) + '" alt=""><img src="' + esc(sel.img || cur.img) + '" alt="">';
        pairEl.hidden = !on;
      }
      if (!built) return;

      /* Bolso 1 */
      els.b1thumb.innerHTML = D.perso
        ? pvHtml(cur.tok, b.sin ? '' : b.val, 'bm-arm__thumb', true)
        : '<span class="bm-arm__thumb"><img src="' + esc(cur.img) + '" alt="" loading="lazy"></span>';
      if (els.b1name) els.b1name.textContent = 'Bolso 1 · ' + cur.name;
      if (els.colorname1) els.colorname1.textContent = 'Color: ' + cur.name;
      if (D.perso) {
        els.b1sub.textContent = b.sin ? 'Sin iniciales' : (b.val ? 'Iniciales: ' + b.val : 'Faltan sus iniciales');
        els.b1sub.classList.toggle('is-warn', !b.ok);
        els.b1ed.hidden = !b1Editing;
        var shown = b.sin ? '' : b.val;
        if (document.activeElement !== els.ini1 && els.ini1.value !== shown) els.ini1.value = shown;
        els.ini1.disabled = b.sin;
        els.sin1.setAttribute('aria-pressed', b.sin ? 'true' : 'false');
        els.pv1.innerHTML = pvHtml(cur.tok, shown, '', true);
      } else {
        els.b1sub.textContent = direct ? modelName(cur.tok, cur.name) : 'El de esta ficha';
      }
      els.b1ok.hidden = !b.ok;
      els.b1edit.hidden = !D.perso || b1Editing;

      /* 2.º color */
      els.sws.forEach(function (bt) {
        var g = bt.getAttribute('data-g') || '2';
        var o = swList(g)[Number(bt.getAttribute('data-i'))];
        var isOn = o === (g === '1' ? cur : sel);
        bt.classList.toggle('is-on', isOn);
        bt.setAttribute('aria-checked', isOn ? 'true' : 'false');
        bt.tabIndex = isOn ? 0 : -1;
      });
      els.colorname.textContent = 'Color: ' + sel.name;

      /* Iniciales del 2.º */
      if (D.perso) {
        els.ini2.disabled = b2.sin;
        els.pv2.innerHTML = pvHtml(sel.tok, b2.sin ? '' : b2.val, '', false);
        els.sin.setAttribute('aria-pressed', b2.sin ? 'true' : 'false');
        var canSame = !!b.val && !b.sin;
        els.same.hidden = !canSame;
        if (canSame) {
          els.same.textContent = 'Mismas iniciales (' + clean(b.val, maxB2) + ')';
          els.same.setAttribute('aria-pressed', (!b2.sin && b2.val && b2.val === clean(b.val, maxB2)) ? 'true' : 'false');
        }
      }

      /* Ahorro */
      els.save.hidden = !(pr.ahorro > 0);
      els.saveT.innerHTML = 'Ahorras <b>' + money(pr.ahorro) + '</b> frente a 2 sueltos (' + money(pr.sueltos) + ')';

      /* Resumen */
      var ready = b.ok && !sel.out && b2ok();
      els.done.hidden = !ready;
      els.pend.hidden = ready;
      els.stage.hidden = !ready;
      els.lines.hidden = !ready;
      els.falta.hidden = ready;
      var n1 = modelName(cur.tok, cur.name), n2 = modelName(sel.tok, sel.name);
      if (ready) {
        els.stage.innerHTML = D.perso
          ? pvHtml(cur.tok, b.sin ? '' : b.val, '', true) + pvHtml(sel.tok, b2.sin ? '' : b2.val, '', false)
          : plainHtml(cur.img) + plainHtml(sel.img || cur.img);
        var hex1 = cur.hex || (curSib && curSib.hex) || '#D2D2D7';
        var hex2 = sel.hex || '#D2D2D7';
        var line = function (name, hex, n, ini, sin) {
          return '<div class="bm-arm__ln"><span class="bm-arm__dot" style="background:' + esc(hex) + '"></span>' +
            '<span class="bm-arm__lt">' + esc(name) + ' <span>· bolso ' + n + '</span></span>' +
            (D.perso ? '<span class="bm-arm__li' + (sin ? ' is-sin' : '') + '">' + (sin ? 'Sin iniciales' : esc(ini)) + '</span>' : '') + '</div>';
        };
        els.lines.innerHTML = line(n1, hex1, 1, b.val, b.sin) + line(n2, hex2, 2, b2.val, b2.sin);
      } else {
        var f = [];
        if (!b.ok) f.push('Escribe las iniciales del 1.er bolso o toca «Sin iniciales».');
        if (sel.out) f.push('Elige el color del 2.º bolso.');
        if (!b2ok()) f.push('Escribe las iniciales del 2.º bolso o toca «Sin iniciales».');
        els.falta.innerHTML = f.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('');
      }
      els.ta.textContent = money(pr.combo);
      els.tb.textContent = '2 bolsos · ' + money(pr.each) + ' cada uno';
      els.was.innerHTML = pr.ahorro > 0 ? '2 sueltos: <s>' + money(pr.sueltos) + '</s>' : '';
      els.pill.hidden = !(pr.ahorro > 0);
      els.pill.textContent = 'Ahorras ' + money(pr.ahorro);
      var express = Number(sel.v.id) === Number(D.expressVariant);
      var tiles = [
        '<div>' + ICON_TRUCK + (express ? '<b>Envío EXPRESS gratis</b>sale en menos de 24 h hábiles' : '<b>Envío gratis</b>principales ciudades') + '</div>',
        '<div>' + ICON_SHIELD + '<b>6 meses</b>de garantía</div>'
      ];
      if (D.perso) tiles.push('<div>' + ICON_SPARK + '<b>Bordado</b>personalizado</div>');
      els.trust.style.setProperty('--n', tiles.length);
      els.trust.innerHTML = tiles.join('');
      if (!busy) els.add.textContent = 'Agregar combo · ' + money(pr.combo);
      els.add.classList.toggle('is-pend', !ready);
      els.after.textContent = 'Entra al carrito como 1 combo: ' + cur.name + ' + ' + sel.name + (D.perso ? ', con las iniciales de cada bolso.' : '.');
      updateSticky(pr);
      syncVariant();
    }

    /* Ficha directa: el precio de arriba (con su tachado y su %), la línea del cupón y la URL siguen a la
       pareja elegida. El campo «id» del formulario de la ficha pasa a la variante elegida (solo si ya es
       una variante de ESTE combo, como hace bm-personalizer) y su «change» hace que bm-ficha.js repinte
       el precio corto del celular, el cupón y la barra; el precio de Dawn (escritorio) se trae de la
       tienda con la sección renderizada para esa variante (mismo HTML que pinta Dawn). */
    var lastVid = null, priceCache = {}, priceTimer = null, armReady = false;
    /* v122 · 19-oct-2026: el precio y la foto de la pareja comparten una sola petición por variante (antes se pedía 2 veces). */
    var secPend = {};
    function traerSeccion(vid) {
      if (!secPend[vid]) {
        var url = (sec.dataset.url || window.location.pathname) + '?variant=' + vid + '&section_id=' + encodeURIComponent(sec.dataset.section);
        secPend[vid] = fetch(url, { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .catch(function (e) { delete secPend[vid]; throw e; });
      }
      return secPend[vid];
    }
    function syncVariant() {
      if (!direct || !sel || !sel.v) return;
      var vid = String(sel.v.id);
      if (vid === lastVid) return;
      var first = lastVid === null;
      lastVid = vid;
      var mine = {};
      D.variants.forEach(function (v) { mine[String(v.id)] = 1; });
      document.querySelectorAll('form[action*="/cart/add"] [name="id"], product-form [name="id"]').forEach(function (inp) {
        if (!mine[String(inp.value)] || inp.value === vid) return;
        inp.value = vid;
        try { inp.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
      });
      if (armReady) {
        try { var u = new URL(window.location.href); u.searchParams.set('variant', vid); window.history.replaceState(window.history.state, '', u.toString()); } catch (e) {}
        fotoDePareja(sel.v);
      }
      var box = (sec && sec !== document.body && sec.dataset && sec.dataset.section) ? document.getElementById('price-' + sec.dataset.section) : null;
      if (!box || D.single) return;
      if (first && D.firstVid && String(D.firstVid) === vid) return; /* ya viene pintado para esta variante */
      if (priceCache[vid]) { box.innerHTML = priceCache[vid]; return; }
      clearTimeout(priceTimer);
      function pedir(intento) {
        traerSeccion(vid)
          .then(function (html) {
            var nb = new DOMParser().parseFromString(html, 'text/html').getElementById(box.id);
            if (!nb) return;
            priceCache[vid] = nb.innerHTML;
            if (String(sel.v.id) === vid) box.innerHTML = nb.innerHTML;
          })
          .catch(function () { if (intento < 2 && String(sel.v.id) === vid) setTimeout(function () { pedir(intento + 1); }, 2500); });
      }
      priceTimer = setTimeout(function () { pedir(0); }, 120);
    }

    /* v120 · 17-oct-2026 (Carol, 16-oct: «se ven dos negros aunque elija Blue + Brown»): en la ficha directa, la foto
       grande de arriba sigue a la pareja elegida. La galería de los combos solo muestra la foto de la variante elegida
       (Dawn oculta las de las otras variantes), así que se trae la galería de esa variante (misma sección renderizada
       por la tienda, como el precio) y se cambia sin mover la página. Si la foto ya está en la galería, solo se pone
       de primera. */
    var galCache = {}, galPend = null;
    function liberarFotos(scope) {
      scope.querySelectorAll('img[data-bm-src], img[data-bm-srcset]').forEach(function (im) {
        if (!im.getAttribute('srcset') && im.getAttribute('data-bm-srcset')) im.setAttribute('srcset', im.getAttribute('data-bm-srcset'));
        if (!im.getAttribute('src') && im.getAttribute('data-bm-src')) im.setAttribute('src', im.getAttribute('data-bm-src'));
      });
    }
    function ponerGaleria(gal, html) {
      var nueva = new DOMParser().parseFromString(html, 'text/html').getElementById(gal.id);
      if (!nueva) return;
      liberarFotos(nueva);
      /* Se cambian solo las fotos (los <li>) dentro de las mismas listas: así siguen valiendo las referencias que
         tienen otros scripts (WhatsApp sobre la foto en bm-ficha.js, contador del deslizador de Dawn). */
      ['.product__media-list', '.thumbnail-list'].forEach(function (q) {
        var vieja = gal.querySelector(q), otra = nueva.querySelector(q);
        if (!vieja || !otra) return;
        vieja.textContent = '';
        Array.prototype.slice.call(otra.children).forEach(function (n) { vieja.appendChild(document.importNode(n, true)); });
        try { vieja.scrollLeft = 0; } catch (e) {}
      });
      var viewer = gal.elements && gal.elements.viewer;
      if (viewer && typeof viewer.resetPages === 'function') { try { viewer.resetPages(); } catch (e) {} }
      var li0 = gal.querySelector('.product__media-list > li[data-media-id]');
      if (li0) zoomDePareja(li0.getAttribute('data-media-id').split('-').pop(), li0);
      window.dispatchEvent(new Event('resize'));
    }
    /* v122 · 19-oct-2026: el zoom (modal de Dawn) muestra la foto de la pareja elegida. En Tote y MINIS esa foto no
       estaba en el modal y al ampliarla salía un error y la foto Negro + Negro. */
    function zoomDePareja(mediaId, li) {
      var c = document.querySelector('product-modal .product-media-modal__content');
      if (!c || !mediaId) return;
      c.querySelectorAll('[data-bm-vpar]').forEach(function (n) { if (n.getAttribute('data-media-id') !== mediaId) n.remove(); });
      var m = c.querySelector('[data-media-id="' + mediaId + '"]');
      if (!m) {
        var im = li && li.querySelector('img');
        if (!im) return;
        m = document.createElement('img');
        m.className = 'global-media-settings global-media-settings--no-shadow product__media-item--variant';
        m.setAttribute('data-media-id', mediaId);
        m.setAttribute('data-bm-vpar', '1');
        var ss = im.getAttribute('srcset') || im.getAttribute('data-bm-srcset');
        if (ss) m.setAttribute('srcset', ss);
        m.setAttribute('sizes', '(min-width: 750px) calc(100vw - 22rem), 1100px');
        m.src = im.getAttribute('src') || im.getAttribute('data-bm-src') || '';
        m.alt = im.alt || '';
        m.loading = 'lazy';
        m.width = 1100;
        m.height = Math.round(1100 * (im.naturalHeight || 1) / (im.naturalWidth || 1));
      }
      if (c.firstElementChild !== m) c.prepend(m);
    }
    function fotoDePareja(v) {
      /* v122: cualquier salida temprana anula la respuesta pendiente de otra pareja (antes, si la tienda respondía
         lento, la foto volvía a la pareja anterior). */
      galPend = v ? String(v.id) : null;
      if (!v || !v.media) return;
      var gal = document.querySelector('media-gallery[id^="MediaGallery-"]');
      if (!gal) return;
      var li = gal.querySelector('[data-media-id$="-' + v.media + '"]');
      /* v121 · 19-oct-2026 (077): en los combos de Tote y MINIS las fotos «Color + Color» no van en la galería (la portada
         es la original con iniciales); quedan guardadas en <template data-bm-vmedia> y aquí se pone la de la pareja elegida. */
      if (!li) {
        var tpl = gal.querySelector('template[data-bm-vmedia]');
        var t = tpl && tpl.content ? tpl.content.querySelector('[data-media-id$="-' + v.media + '"]') : null;
        var lista = gal.querySelector('.product__media-list');
        if (t && lista) {
          lista.querySelectorAll('[data-bm-vpar]').forEach(function (n) { n.remove(); });
          li = document.importNode(t, true);
          li.setAttribute('data-bm-vpar', '1');
          lista.prepend(li);
        }
      }
      if (li && li.parentElement) {
        var list = li.parentElement;
        liberarFotos(li);
        if (list.firstElementChild !== li) list.prepend(li);
        gal.querySelectorAll('[data-media-id]').forEach(function (e) { e.classList.toggle('is-active', e === li); });
        try { list.scrollTo({ left: 0, behavior: 'smooth' }); } catch (e) { list.scrollLeft = 0; }
        var viewer = gal.elements && gal.elements.viewer;
        if (viewer && typeof viewer.resetPages === 'function') { try { viewer.resetPages(); } catch (e) {} }
        zoomDePareja(String(v.media), li);
        return;
      }
      if (!sec || !sec.dataset || !sec.dataset.section) return;
      var vid = String(v.id);
      if (galCache[vid]) { ponerGaleria(gal, galCache[vid]); return; }
      galPend = vid;
      traerSeccion(vid)
        .then(function (html) {
          galCache[vid] = html;
          var g = document.querySelector('media-gallery[id^="MediaGallery-"]');
          if (g && galPend === vid && sel && sel.v && String(sel.v.id) === vid) ponerGaleria(g, html);
        })
        .catch(function () {});
    }

    function hideMsgs() {
      if (els.err) els.err.hidden = true;
      if (els.okmsg) els.okmsg.hidden = true;
    }
    function pide(el) {
      if (!el) return;
      el.classList.remove('bm-arm__pide'); void el.offsetWidth; el.classList.add('bm-arm__pide');
      setTimeout(function () { el.classList.remove('bm-arm__pide'); }, 1200);
    }
    function goBag1() {
      if (!D.perso) return;
      b1Editing = true;
      update();
      if (!els.ini1) return;
      els.b1ed.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { try { els.ini1.focus({ preventScroll: true }); } catch (e) { els.ini1.focus(); } }, 350);
      if (!bag1().ok) pide(els.ini1);
    }

    /* ---------- Abrir / cerrar ---------- */
    function setMode(next, scroll) {
      on = !!next;
      if (one) {
        one.classList.toggle('is-on', !on);
        one.setAttribute('aria-checked', on ? 'false' : 'true');
        head.setAttribute('aria-checked', on ? 'true' : 'false');
      }
      card.classList.toggle('is-on', on);
      if (on && !built) b1Editing = D.perso && (direct || !bag1().ok);
      if (on) build();
      panel.hidden = !on;
      if (els.out) els.out.hidden = !on;
      if (sec && sec !== document.body) {
        sec.classList.toggle('bm-arm-sec-on', on);
        /* Con el combo, las iniciales del bolso 1 se editan dentro del armado: el campo suelto
           del personalizador se esconde (sigue en la página y sigue siendo la fuente de verdad). */
        sec.classList.toggle('bm-arm-sec-perso', on && !!D.perso);
        /* Ficha directa del combo: el armado reemplaza también al selector de variantes y al personalizador. */
        sec.classList.toggle('bm-arm-sec-direct', on && direct);
      }
      document.body.classList.toggle('bm-arm-body-on', on);
      update();
      if (!on && sticky) sticky.classList.remove('is-visible');
      if (on && scroll) {
        var r = card.getBoundingClientRect();
        if (r.top < 70 || r.top > window.innerHeight * 0.55) {
          window.scrollTo({ top: window.pageYOffset + r.top - 90, behavior: 'smooth' });
        }
      }
      if (live && !direct) live.textContent = on ? 'Combo ×2 elegido: elige el color del 2.º bolso.' : '1 unidad elegida.';
    }
    if (one) one.addEventListener('click', function () { if (on) setMode(false); });
    head.addEventListener('click', function (e) {
      e.preventDefault();
      if (!on) setMode(true, true);
    });
    head.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); if (!on) setMode(true, true); }
    });
    if (one) [one, head].forEach(function (el) {
      el.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var goCombo = el === one;
          setMode(goCombo, goCombo);
          (goCombo ? head : one).focus();
        }
      });
    });

    /* Iniciales del bolso 1: se leen en vivo del personalizador. */
    document.addEventListener('input', function (e) { if (on && e.target === b1Input) update(); });
    document.addEventListener('change', function (e) {
      if (on && e.target && e.target.matches && e.target.matches('#bmPerso .bm-perso__noini-cb')) update();
    });

    /* Con el combo elegido, cualquier «Agregar al carrito» de ESTA ficha (por ejemplo la barra fija
       que hace clic en el botón principal) agrega el combo, nunca 1 unidad. Fase de captura en window:
       corre antes que el resto de manejadores. */
    var SEL_BUY = '.product-form__submit, .bm-sticky-atc__btn, .bm-perso-quickbuy';
    window.addEventListener('click', function (e) {
      if (!on) return;
      var t = e.target && e.target.closest ? e.target.closest(SEL_BUY) : null;
      if (!t) return;
      if (!(sec.contains(t) || t.closest('#bmStickyAtc'))) return;
      e.preventDefault(); e.stopImmediatePropagation();
      addCombo();
    }, true);
    window.addEventListener('submit', function (e) {
      if (!on) return;
      var f = e.target;
      if (!f || !f.matches || !f.matches('form[action*="/cart/add"]') || !sec.contains(f)) return;
      e.preventDefault(); e.stopImmediatePropagation();
      addCombo();
    }, true);

    /* ---------- Agregar al carrito ---------- */
    function propName(i, tok) {
      return D.bagLabel + ' ' + cap(tok) + D.proSuffix + ' (0' + i + ') - Iniciales';
    }
    function addCombo() {
      if (busy) return;
      if (!built) build();
      hideMsgs();
      var b = bag1();
      if (!b.ok) { update(); els.falta.hidden = false; goBag1(); return; }
      if (sel.out) { update(); els.b2.scrollIntoView({ behavior: 'smooth', block: 'center' }); pide(els.sws2); return; }
      if (!b2ok()) {
        update();
        els.ini2.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { try { els.ini2.focus({ preventScroll: true }); } catch (e) {} }, 350);
        pide(els.ini2);
        return;
      }
      var vid = sel.v.id;
      var fd = new FormData();
      fd.append('id', String(vid));
      fd.append('quantity', '1');
      if (D.perso) {
        fd.append('properties[' + propName(1, cur.tok) + ']', b.sin ? 'Sin iniciales' : b.val);
        fd.append('properties[' + propName(2, sel.tok) + ']', b2.sin ? 'Sin iniciales' : b2.val);
      }
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        fd.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(els.add);
      }
      var cfg = (typeof window.fetchConfig === 'function') ? window.fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/javascript' } };
      cfg.headers = cfg.headers || {};
      cfg.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete cfg.headers['Content-Type'];
      cfg.body = fd;
      busy = true;
      els.add.classList.add('is-wait');
      els.add.setAttribute('aria-busy', 'true');
      els.add.textContent = 'Agregando combo…';
      if (sticky) sticky.querySelector('button').textContent = 'Agregando…';
      var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(url, cfg)
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status) {
            els.err.textContent = res.description || res.message || 'No pudimos agregar el combo. Intenta de nuevo.';
            els.err.hidden = false;
            return;
          }
          if (!cart) { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; return; }
          try {
            /* PUB_SUB_EVENTS es un const global de Dawn (constants.js): no cuelga de window. */
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bm-combo-armar', productVariantId: String(vid), cartData: res });
            }
          } catch (e) {}
          try { cart.renderContents(res); } catch (e) { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; return; }
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          els.okmsg.hidden = false;
          if (live) live.textContent = 'Combo agregado al carrito.';
        })
        .catch(function () {
          els.err.textContent = 'No pudimos agregar el combo. Revisa tu conexión e intenta de nuevo.';
          els.err.hidden = false;
        })
        .then(function () {
          busy = false;
          els.add.classList.remove('is-wait');
          els.add.removeAttribute('aria-busy');
          if (sticky) sticky.querySelector('button').textContent = 'Agregar combo';
          update();
        });
    }

    /* ---------- Barra fija del combo (celular) ---------- */
    var sticky = null, addVisible = true;
    function buildSticky() {
      if (sticky) return;
      sticky = document.createElement('div');
      sticky.className = 'bm-arm-sticky';
      sticky.innerHTML = '<div class="bm-arm-sticky__p"><span class="bm-arm-sticky__a" data-a></span><span class="bm-arm-sticky__b" data-b></span></div>' +
        '<button type="button" class="bm-arm-sticky__btn">Agregar combo</button>';
      document.body.appendChild(sticky);
      sticky.querySelector('button').addEventListener('click', addCombo);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          en.forEach(function (x) { addVisible = x.isIntersecting; });
          updateSticky();
        }, { rootMargin: '0px 0px -60px 0px' }).observe(els.add);
      }
      window.addEventListener('resize', function () { updateSticky(); });
    }
    function updateSticky(pr) {
      if (!sticky) return;
      pr = pr || prices();
      sticky.querySelector('[data-a]').textContent = money(pr.combo);
      sticky.querySelector('[data-b]').textContent = money(pr.each) + ' cada uno';
      sticky.classList.toggle('is-visible', on && !addVisible && window.innerWidth < 750);
    }

    /* Ficha directa del combo: el combo ya viene elegido y armado. */
    /* v121 · 19-oct-2026 (058): si la pareja con que abre el armado no es la de la foto que pintó la tienda (la 1.ª variante),
       se pone la foto de esa pareja. Pasaba en el Combo Classic: abría en Negro + Negro con la foto de Café + Negro. */
    if (direct) { setMode(true, false); armReady = true; if (sel && sel.v && String(sel.v.id) !== String(D.firstVid)) fotoDePareja(sel.v); }
    else update();
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-bm-arm]')).forEach(init);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
